import "core-js/modules/es6.object.freeze";
import { colors, colorsRefresh } from '../colors';
import { strokeWidths, strokeWidthsRefresh } from '../stroke-widths';
import units from '../units'; // @TODO: Handle different handle styles

var getHandleStyle = function getHandleStyle(borderColor) {
  return "\n    border-bottom: " + strokeWidths["default"] + " solid " + colors[borderColor] + ";\n    padding: " + units.getValues([1, 1, 1, 0]) + ";\n";
};

var getHandleStyleRefresh = function getHandleStyleRefresh(borderColor) {
  return "\n    border-bottom: " + strokeWidthsRefresh["default"] + " solid " + colorsRefresh[borderColor] + ";\n    padding: " + units.getValues([1, 1, 1, 0]) + ";\n";
};

var getContainerStyle = function getContainerStyle() {
  return "\n    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.22);\n    /* Adds margin to the bottom of the page if dropdown is at bottom */\n    margin-bottom: " + units.getValue(4) + ";\n";
};

var headerStyle = "\n    padding: " + units.getValue(2) + ";\n";
export var dropdown = Object.freeze({
  getContainerStyle: getContainerStyle,
  getHandleStyle: getHandleStyle,
  headerStyle: headerStyle
});
export var dropdownRefresh = Object.freeze({
  getContainerStyle: getContainerStyle,
  getHandleStyle: getHandleStyleRefresh,
  headerStyle: headerStyle
});